import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { clienteService } from "@/services/api/cliente.service";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;

/** Critério de filtro das filiais (não há tipo dedicado no backend). */
type FilialFiltrosCriteria = Record<string, unknown>;

/**
 * Query keys do domínio "filiais". `list`/`pendentes` mantêm as keys legadas
 * (`['filiais-list']` / `['filiais-pendentes-list']`) — as mesmas que `useFilialActions`
 * invalida —, então as mutações existentes continuam alcançando estas listas.
 */
export const filiaisKeys = {
  list: ["filiais-list"] as const,
  pendentes: ["filiais-pendentes-list"] as const,
  filtros: ["filiais-filtros"] as const,
};

export const filiaisQueries = {
  list: (criteria: FilialFiltrosCriteria) =>
    queryOptions({
      queryKey: [...filiaisKeys.list, criteria],
      queryFn: () => clienteService.listFiliais(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  pendentes: (criteria: FilialFiltrosCriteria) =>
    queryOptions({
      queryKey: [...filiaisKeys.pendentes, criteria],
      queryFn: () => clienteService.listFiliaisPendentes(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: filiaisKeys.filtros,
      queryFn: () => clienteService.getFiltrosFilial(),
      staleTime: FILTROS_STALE,
    }),
};
